import $ from 'jquery';
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".header", {existing: true}, function (){

  gsap.to(".img-container-pre-interni-1", {
    duration: 2,
    scrollTrigger: {
      trigger: ".img-container-pre-interni-1",
      start: 'top bottom',
      toggleClass: "move",
    }
  })
  gsap.to(".img-container-pre-interni-2", {
    duration: 2,
    scrollTrigger: {
      trigger: ".img-container-pre-interni-2",
      start: 'top bottom',
      toggleClass: "move",
    }
  })

  gsap.to(".title-design", {
    duration: 1,
    scrollTrigger: {
      trigger: ".title-design",
      start: 'bottom bottom',
      toggleClass: "animate",
    }
  })
  gsap.to(".title-competenza", {
    duration: 1,
    scrollTrigger: {
      trigger: ".title-competenza",
      start: 'bottom bottom',
      toggleClass: "animate",
    }
  })
  gsap.to(".title-affidabilita", {
    duration: 1,
    scrollTrigger: {
      trigger: ".title-affidabilita",
      start: 'bottom bottom',
      toggleClass: "animate",
    }
  })

})